import React, { useEffect } from "react";

const LINKS = {
  icecream:
    "https://i-screammall.co.kr/goods/detail/10128804?infDispCtgNoGbCd=06&infDispCtgNo=",
  teachers: "https://chathess.teacherville.co.kr/goods/view?no=1184562",
  edutechmall:
    "https://www.s2b.kr/Edutech/product/productDetail.do?estimatecode=202505072024196",
  checklist:
    "https://img.dongascience.com/air/checklist_donga_air_20260126.pdf",
  freeTrial: "https://naver.me/FzsgvIS5",
  purchase: "https://dsstore.dongascience.com/product/c8na6Y62",
  inquiry: "https://litt.ly/dsair_edu",
};

const EduMain = () => {
  useEffect(() => {
    // 외부 CSS 링크 추가
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://img.dongascience.com/air/guide/guide.css";
    document.head.appendChild(link);

    // 컴포넌트 언마운트 시 링크 제거
    return () => {
      document.head.removeChild(link);
    };
  }, []);
  return (
    <div id="airedu" style={{ width: "100vw" }}>
      <div className="top">
        <div className="area">
          <img
            src="https://img.dongascience.com/air/guide/airedu_top.png"
            alt="탐구활동 AI 솔루션 과학동아에어에듀"
          />
        </div>
      </div>

      <div className="check">
        <div className="area">
          <img
            src="https://img.dongascience.com/air/guide/airedu_check01.png"
            alt="두둥! 저희AiR가 더 똑똑해졌어요!"
          />
          <a href={LINKS.checklist} target="_blank" rel="noopener noreferrer">
            <img
              src="https://img.dongascience.com/air/guide/airedu_check02.png"
              alt="학운위 심의를 위한 체크리스트 다운로드"
            />
          </a>
        </div>
      </div>

      <div className="qna">
        <div className="area">
          <img
            src="https://img.dongascience.com/air/guide/airedu_qna.png"
            alt="이런 고민, 혹시 선생님도 있으신가요?"
          />
        </div>
      </div>

      <div className="story">
        <div className="area">
          <img
            src="https://img.dongascience.com/air/guide/airedu_story01.png"
            alt="교수학습지도안 제공"
          />
          <img
            src="https://img.dongascience.com/air/guide/airedu_story02.png"
            alt="활용사례"
          />
        </div>
      </div>

      <div className="free">
        <div className="area">
          <a href={LINKS.freeTrial} target="_blank" rel="noopener noreferrer">
            <img
              src="https://img.dongascience.com/air/guide/airedu_free.png"
              alt="무료 체험 하러가기"
            />
          </a>
        </div>
      </div>

      <div className="use">
        <div className="area">
          <img
            src="https://img.dongascience.com/air/guide/airedu_use.png"
            alt="사용법"
          />
        </div>
      </div>

      <div className="benefit">
        <div className="area">
          <img
            src="https://img.dongascience.com/air/guide/airedu_benefit01.png"
            alt="전용 혜택"
          />
        </div>
      </div>

      <div className="order">
        <div className="area">
          <img
            src="https://img.dongascience.com/air/guide/airedu_benefit02.png"
            alt="전용 혜택"
          />
          <div className="link">
            <a href={LINKS.icecream} target="_blank" rel="noopener noreferrer">
              <img
                src="https://img.dongascience.com/air/guide/airedu_benefit02_1.png"
                alt="아이스크림몰"
              />
            </a>
            <a href={LINKS.teachers} target="_blank" rel="noopener noreferrer">
              <img
                src="https://img.dongascience.com/air/guide/airedu_benefit02_2.png"
                alt="체더스"
              />
            </a>
            <a
              href={LINKS.edutechmall}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://img.dongascience.com/air/guide/airedu_benefit02_3.png"
                alt="에듀테크몰"
              />
            </a>
          </div>
        </div>
      </div>

      <div className="ds">
        <div className="area">
          <a href={LINKS.purchase} target="_blank" rel="noopener noreferrer">
            <img
              src="https://img.dongascience.com/air/guide/airedu_ds01.png"
              alt="특가 구매 하러 가기"
            />
          </a>
          <a href={LINKS.inquiry} target="_blank" rel="noopener noreferrer">
            <img
              src="https://img.dongascience.com/air/guide/airedu_ds02.png"
              alt="도입문의하기"
            />
          </a>
        </div>
      </div>

      <div className="qr">
        <div className="area">
          <img
            src="https://img.dongascience.com/air/guide/airedu_qr.png"
            alt="카카오톡 채널 QR"
          />
        </div>
      </div>
    </div>
  );
};

export default EduMain;
